import React, { useEffect, useState } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import axiosInstance from "../../API/axiosInstance";

const CartScreen = () => {
  const [cartItems, setCartItems] = useState([]);
  const [cartId, setCartId] = useState(null);
  const [userId, setUserId] = useState(null);

  // ✅ Total calculation
  const getTotal = () => {
    return cartItems.reduce((sum, item) => {
      return sum + item.price * item.quantity;
    }, 0);
  };

  // ✅ Fetch cart items
  useEffect(() => {
    const fetchCart = async () => {
      try {
        const token = localStorage.getItem("token");
        const userData = JSON.parse(localStorage.getItem("currentUser"));
        if (userData) setUserId(userData.id);

        const res = await axiosInstance.get(
          `/cart/${userData.id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (res.status === 200) {
          setCartId(res.data.id);
          setCartItems(res.data.items || []);
        }
      } catch (err) {
        console.error("Failed to load cart", err);
      }
    };

    fetchCart();
  }, []);

  const decreaseQuantity = (serviceId) => {
    console.log("Cart ID:", cartId, "Service ID:", serviceId);

    // TODO: call API to decrease quantity
  };

  const increaseQuantity = (serviceId) => {
    console.log("Increase qty for:", serviceId);
    // TODO: call API to increase quantity
  };

  return (
    <div className="container py-4">
      <h2 className="fw-bold mb-4">My Cart</h2>

      {cartItems.length === 0 ? (
        <div className="text-center py-5">
          <i className="bi bi-cart-x" style={{ fontSize: "4rem", color: "grey" }}></i>
          <h5 className="mt-3 text-muted">Your cart is empty</h5>
          <p className="text-secondary">Try adding a service!</p>
        </div>
      ) : (
        <div className="row">
          {/* Left Column - Cart Items */}
          <div className="col-lg-8 col-md-7 col-12 mb-3">
            {cartItems.map((item, index) => (
              <div
                key={index}
                className="card mb-3 shadow-sm border-0"
                style={{ borderRadius: "12px" }}
              >
                <div className="card-body d-flex align-items-center">
                  {/* Item Image */}
                  <div className="me-3">
                    {item.image ? (
                      <img
                        src={item.image}
                        alt={item.serviceName}
                        style={{
                          height: "60px",
                          width: "60px",
                          borderRadius: "8px",
                          objectFit: "cover",
                        }}
                        onError={(e) => {
                          e.target.src = "https://via.placeholder.com/60";
                        }}
                      />
                    ) : (
                      <div
                        className="d-flex justify-content-center align-items-center"
                        style={{
                          height: "60px",
                          width: "60px",
                          borderRadius: "8px",
                          background: "#f0f0f0",
                        }}
                      >
                        <i className="bi bi-bag text-muted"></i>
                      </div>
                    )}
                  </div>

                  {/* Item Info */}
                  <div className="flex-grow-1">
                    <h6 className="fw-bold mb-1">{item.serviceName}</h6>
                    <small className="text-muted">₹{item.price}</small>
                  </div>

                  {/* Quantity Stepper + Price */}
                  <div className="text-end">
                    <div className="d-inline-flex align-items-center justify-content-center border rounded-pill px-2 bg-light">

                      {/* Quantity centered */}
                      <span className="fw-bold text-center mx-3" style={{ minWidth: "24px" }}>
                        {item.quantity}
                      </span>

                    </div>

                    <div className="fw-bold text-dark mt-2">
                      ₹{(item.price * item.quantity).toFixed(2)}
                    </div>
                  </div>


                </div>
              </div>
            ))}
          </div>

          {/* Right Column - Total + Checkout */}
          <div className="col-lg-4 col-md-5 col-12">
            <div
              className="card shadow-sm border-0"
              style={{ borderRadius: "16px" }}
            >
              <div className="card-body">
                <h5 className="fw-bold">Order Summary</h5>
                <div className="d-flex justify-content-between my-3">
                  <span>Total:</span>
                  <span className="fw-bold">₹{getTotal().toFixed(2)}</span>
                </div>
                <button className="btn btn-primary w-100 fw-bold">
                  Proceed to Checkout
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CartScreen;
